import { IFinanceInfluencer } from "@shared/lib/types/briefCampains";
import { useState } from "react";
import { Modal, Row } from "antd";
import { Button } from "@shared/ui/Button";
import { SelectVendorBilling } from "@features/selectVendorBilling/SelectVendorBilling";
import styles from "./styles.module.scss";

export function BillingEmptyState({
  campaignInfluencer,
}: {
  campaignInfluencer?: IFinanceInfluencer["campaignInfluencer"];
}) {
  const [isVendorBillingModalProps, setVendorBillingModalProps] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  return (
    <Row justify="center" align="middle">
      <div className={styles.card} style={{ width: "660px" }}>
        <div className={styles.emptyState}>
          <div className={styles.emptyTitle}>
            Looks like this influencer doesn’t have <br />
            billing details attached yet.
          </div>
          <img
            src={`/paymentNotFound.svg`}
            alt="Billing details not found"
            className={styles.emptyIllustration}
          />
          <div className={styles.emptyDesc}>
            Without billing details we can’t take <b>Payment</b> actions.
          </div>
          <div className={styles.emptyActions}>
            <Button
              type="primary"
              style={{ width: "400px" }}
              onClick={() => setVendorBillingModalProps({ visible: true })}
            >
              Attach Billing Details
            </Button>
          </div>
        </div>
      </div>

      <Modal
        title="Confirm Billing"
        destroyOnClose
        footer={null}
        width={1000}
        open={isVendorBillingModalProps.visible}
        onCancel={() => setVendorBillingModalProps({ visible: false })}
      >
        {isVendorBillingModalProps.visible && (
          <SelectVendorBilling
            campaignInfluencerId={campaignInfluencer?._id || ""}
            influencerId={campaignInfluencer?.influencerId || ""}
            name={campaignInfluencer?.socialMedia?.username || ""}
            profilePicUrl={campaignInfluencer?.socialMedia?.profilePicUrl || ""}
            onClose={() => setVendorBillingModalProps({ visible: false })}
          />
        )}
      </Modal>
    </Row>
  );
}
